<script setup lang="ts">
/**
 * 統一品牌標誌 (App Logo)
 * 1. 支援 isLight (透明 Header/深色背景模式)
 * 2. 整合 Scholar Blue (#2563EB) 與 Scholar Orange (#F97316)
 * 3. 具備高質感的微交互 Hover 效果
 */
defineProps<{ isLight?: boolean }>();
</script>
<template>
  <div
    class="flex items-center gap-2 group cursor-pointer transition-transform active:scale-95 select-none"
  >
    <!-- SVG 向量優化，確保在折疊手機與高分屏下無鋸齒 -->
    <svg
      width="180"
      height="40"
      viewBox="0 0 180 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="h-8 md:h-9 w-auto"
    >
      <!-- 品牌圖騰：幾何菱形結構 -->
      <path
        d="M28 8L44 20L28 32L12 20L28 8Z"
        :fill="isLight ? '#FFFFFF' : '#F97316'"
        class="transition-colors duration-500"
      />
      <path
        d="M44 20V28"
        :stroke="isLight ? '#FFFFFF' : '#F97316'"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <!-- 字體品牌名：使用 Plus Jakarta Sans 風格字型 (SVG Text Path) -->
      <text
        x="50"
        y="30"
        font-family="Plus Jakarta Sans, sans-serif"
        font-weight="900"
        font-size="28"
        :fill="isLight ? '#FFFFFF' : '#2563EB'"
        class="transition-colors duration-500 tracking-tighter"
      >
        scholar
      </text>
      <text
        x="135"
        y="30"
        font-family="Plus Jakarta Sans, sans-serif"
        font-weight="900"
        font-size="28"
        :fill="isLight ? '#FFFFFF' : '#F97316'"
        class="transition-colors duration-500 tracking-tighter italic"
      >
        trip
      </text>
    </svg>
  </div>
</template>
